module.exports = __webpack_public_path__ + "static/img/app_store_badge.67e0b03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/app_store_badge.png
// module id = 8Vhn
// module chunks = 1